import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import polygon from "../assets/images/Polygon 56.png";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { SpinnerCircular } from "spinners-react";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import arrowleft from "../assets/images/arrow-left.png";

const BucketVideos = () => {
  const token = GetStorage.get("xAuthToken");
  const [loading, setLoading] = useState(true);
  const [bucketvideo, setBucketvideos] = useState([]);
  const [error, setError] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    handleShowsBucketVideos();
  }, [id]);

  const handleShowsBucketVideos = () => {
    setLoading(true);

    http
      .get(`api/admin/analyst/${id}/bucket?token=${token}`)
      .then((res) => {
        console.log("category in  ------->>>>", res.data);
        setBucketvideos(res.data);

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  return (
    <>
      <div className="wrapper">
        <Nav />
        <div id="content">
          <header>
            <div className="dashboard_header">
              <button
                onClick={() => navigate("/applicants")}
                type="button"
                className="btn btn-link  "
              >
                {" "}
                <img src={arrowleft} className="img-fluid" />{" "}
              </button>
              <DropdownRight />
            </div>
          </header>
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
            {loading ? (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  marginTop: 100,
                }}
              >
                <SpinnerCircular size="15%" />
              </div>
            ) : (
              <>
                {bucketvideo.length > 0 ? (
                  bucketvideo.map((item) => (
                    <div key={item.id} className="vedio_datile">
                      <div className="vedio">
                        <Link
                          style={{
                            position: "relative",
                          }}
                          to={{
                            pathname: `/video/${id}`,
                          }}
                          state={{ name: item.path, id: item.id }}
                        >
                          <video src={item.path} className="img-fluid" />
                          <img
                            src={polygon}
                            alt=""
                            style={{
                              position: "absolute",
                              marginTop: -115,
                              marginLeft: 150,
                              width: 25,
                              height: 25,
                            }}
                          />
                        </Link>
                      </div>
                      <p className="text-show-file mt-2">
                        {item.path.split("/")[item.path.split("/").length - 1]}
                      </p>
                    </div>
                  ))
                ) : (
                  <h3 style={{ marginTop: "50px" }}>No videos in bucket</h3>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BucketVideos;
